import React from 'react';

interface Props extends React.SVGAttributes<SVGElement> {
  color?: string;
  size?: number;
}

export const ChatIcon: React.FC<Props> = ({
  color = 'currentColor',
  size = 24,
  ...props
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 18C16.4183 18 20 14.866 20 11C20 7.13401 16.4183 4 12 4C7.58172 4 4 7.13401 4 11C4 12.4358 4.49404 13.7707 5.3415 14.8815C5.47613 15.1546 5.75357 16.0287 5 17.7364C4.63024 18.4941 4.46711 19 5 19C6.12068 19 6.64893 18.6353 7.19788 18.2563C7.65602 17.9399 8.12858 17.6137 8.97197 17.4812C9.90599 17.8156 10.9284 18 12 18Z"
    />
    <style jsx>{`
      svg {
        fill: ${color};
        height: ${size}px;
        width: ${size}px;
        display: block;
      }
    `}</style>
  </svg>
);
